/**
 * This component renders the corresponding svg
 */
import React, { CSSProperties } from 'react';
// @ts-ignore
import { ReactComponent as Icon } from './AssignmentWithPen.svg';
// @ts-ignore
import { ReactComponent as IconOutlined } from './AssignmentWithPenOutline.svg';
interface AssignmentWithPenIconProps {
  style?: CSSProperties;
  variant?: 'filled' | 'outlined';
}
const AssignmentWithPenIcon: React.FC<AssignmentWithPenIconProps> = (
  props: AssignmentWithPenIconProps
) => {
  const { style, variant } = props;
  return (
    <div style={{ position: 'relative', margin: '0 2px', ...style }}>
      {variant == 'outlined' ? <IconOutlined /> : <Icon />}
    </div>
  );
};
export default AssignmentWithPenIcon;
